import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/custom.scss";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "../src/redux/store";
import { BrowserRouter } from "react-router-dom";
import TagManager from "react-gtm-module";
import GetInTouchUnAuth from "./pages/UnSecured/GetInTouch/GetInTouchUnAuth";
import { REProvider } from "./context/RetirementExplorerContext";
import { RAProvider } from "./context/RAContextProviders";

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID,
};
TagManager.initialize(tagManagerArgs);
const baseApp =
  process.env.REACT_APP_ENV === "dev"
    ? "/dev"
    : process.env.REACT_APP_ENV === "qa"
      ? "/qa"
      : process.env.REACT_APP_ENV === "uat"
        ? "/uat"
        : "/";
const root = ReactDOM.createRoot(document.getElementById("root"));
const path = window.location.href;
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={baseApp}>
        {path.includes("get-in-touch-form") ? (
          <GetInTouchUnAuth />
        ) : (
          <RAProvider>
            <REProvider>
              <App />
            </REProvider>
          </RAProvider>
        )}
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
